export const KEYS = {
  ERROR: {
    EXAMPLE: "Beispiel:"
  }
};
